import gql from 'graphql-tag';

export const getCoursesWithSessionsQuery = gql`
  query GetCoursesWithSessionsQuery($courseIds: [String!]!, $userId: String!) {
    CoursesV1Resource {
      multiGet(ids: $courseIds, showHidden: true, withCorrectBehavior: true) {
        elements {
          id
          slug
          name
          activeAndUpcomingSessions(learnerId: $userId) {
            elements {
              id
              courseId
              startsAt
              endsAt
              isEnrolled
              isEnrollableNow
            }
          }
        }
      }
    }
  }
`;
